import { useState } from "react";

import { Box } from "@seneca/senekit";

import { RenderSignInFormProps } from "features/sign-up/sign-in-form/components/SignInCard/components/SignInCardCommon";

import { SignUpCardAppsContainerProps } from "../containers/SignUpCardAppsContainer";
import SignUpCardFlowsContainer from "../containers/SignUpCardFlowsContainer";
import SignUpOptionsCard from "../forms/SignUpOptionsCard";
import SignUpPasswordlessForm from "../forms/SignUpPasswordlessForm";
import SignUpWithEmailAndPasswordForm from "../forms/SignUpWithEmailAndPasswordForm";

export default function SignUpCardStandard(
  props: SignUpCardAppsContainerProps
) {
  const [formToShow, setFormToShow] = useState<
    "passwordless" | "password" | null
  >(null);

  const [email, setEmail] = useState("");

  const renderForm = (renderProps: RenderSignInFormProps) => (
    <Box
      dataTest="SignUpFormWrapper"
      paddingTop={["xlarge", "none"]}
      height="100%"
    >
      {formToShow === "passwordless" ? (
        <SignUpPasswordlessForm
          loading={renderProps.loading}
          prefilledEmail={renderProps.prefilledEmail}
          redirectAuthenticatedUserTo={renderProps.redirectAuthenticatedUserTo}
          headerMessage={renderProps.headerMessage}
          onClickUsePasswordInstead={email => {
            setFormToShow("password");
            setEmail(email);
          }}
        />
      ) : formToShow === "password" ? (
        <SignUpWithEmailAndPasswordForm
          prefilledEmail={renderProps.prefilledEmail ?? email}
          headerMessage={renderProps.headerMessage}
          accountType={props.accountType}
          linkToNextPage={props.linkToNextPage}
          linkToSignIn={props.linkToSignIn}
        />
      ) : (
        <SignUpOptionsCard
          {...renderProps}
          linkToSignIn={props.linkToSignIn}
          onClickSignUpWithEmailLink={() => setFormToShow("passwordless")}
        />
      )}
    </Box>
  );

  return (
    <SignUpCardFlowsContainer {...props}>{renderForm}</SignUpCardFlowsContainer>
  );
}
